import React from 'react';
import LegalDocumentPage from './LegalDocumentPage';

export default function PrivacyPage() {
  return (
    <LegalDocumentPage
      slug="privacy"
      fallbackTitle="Политика конфиденциальности"
      fallbackFile="/docs/privacy.html"
    />
  );
}